import { useParams } from "react-router";
import t from "@/lang/lang";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { RltBreadcrumbs } from "@/routes/processes/[processId]/rlt/_components/rlt-breadcrumbs";
import { OrdersIndexRoute } from "@/routes/processes/[processId]/rlt/orders/orders-index";

export default function OrdersRoute() {
  const { processId } = useParams();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  if (!data) return null;

  const breadcrumbs = (
    <RltBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Auftragseingänge")}</BreadcrumbPage>
      </BreadcrumbItem>
    </RltBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <OrdersIndexRoute />
    </ProcessPageMainTemplate>
  );
}
